<template>
  <a href="https://www.fotografiska.com/sto/" v-if="branch == 'stockholm'">
    <img src="../../assets/img/logos/stockholm.svg" alt="Fotografiska Stockholm">
  </a>
  <a href="https://www.fotografiska.com/nyc/" v-else-if="branch == 'new_york'">
    <img src="../../assets/img/logos/nyc.svg" alt="Fotografiska New York">
  </a>
  <a href="https://www.fotografiska.com/berlin/" v-else-if="branch == 'berlin'">
    <img src="../../assets/img/logos/berlin.svg" alt="Fotografiska Berlin">
  </a>
</template>
<script>
export default {
  name: 'Logo',
  computed: {
    branch: () => {
      return process.env.FG_APP_BRANCH
    }
  }
}
</script>
<style lang="scss" scoped>
.logo-image {
  transition: width .6s ease-out, opacity .7s ease-out .5s, transform .7s ease-out .5s;
  @media screen and (max-width: 750px) {
    width: 120px;
    height: auto;
  }
}
</style>
